export class SocialLinks {
  static instagram = "https://www.google.com";
  static facebook = "https://www.google.com";
  static twitter = "https://www.google.com";
}
